import { z } from 'zod';

export const DataSetSchema = z
  .object({
    name: z
      .string({ message: 'Name is required' })
      .regex(/^[a-zA-Z0-9 ]+$/, { message: 'Name must not contain special characters' }),
    datasource_type: z.enum(['website', 'menu', 'qa', 'document']),
    configuration: z
      .object({
        url: z
          .string()
          .transform((val) => (val.startsWith('http') ? val : `https://${val}`))
          .refine(
            (val) => {
              const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
              return urlPattern.test(val);
            },
            { message: 'Invalid URL' }
          )
          .optional(),
        scrap_website: z.boolean().optional(),
        exclude_urls: z.any().optional(),
        chunk_token_num: z.any().optional(),
        delimiter: z.string().optional(),
        layout_recognize: z.any().optional(),
        raptor: z
          .object({
            use_raptor: z.any().optional(),
            max_cluster: z.any().optional(),
            max_token: z.any().optional(),
            prompt: z.any().optional(),
            random_seed: z.any().optional(),
            threshold: z.any().optional()
          })
          .optional()
      })
      .optional()
  })
  .superRefine((values, ctx) => {
    if (values.datasource_type === 'website') {
      if (!values.configuration?.url) {
        ctx.addIssue({
          message: 'Url is required',
          code: z.ZodIssueCode.custom,
          path: ['parser_config', 'url']
        });
      }
    }
  });

export type DataSetFormRequest = z.infer<typeof DataSetSchema>;
